const Americaon2022_1=[
    {
        "Contig_Num":"1409",
        "Contig_Len":"782351714",
        "GC":"38.50",
        "Scaffold_Num":"9",
        "Scaffold_Len":"782491714",
        "Gap_Num":"1400",
        "Gap_Len":"140000"
    }
]
let Americaon2022_1Colums=[]
Object.keys(Americaon2022_1[0]).map(key=>{
    Americaon2022_1Colums.push({
        title:key.split("_").join(" "),
        key:key,
        align:"center",
        dataIndex:key
    })
})
export {Americaon2022_1,Americaon2022_1Colums}